const gameConfig = {
  "category": [
      {
          "id": 1,
          "description": null,
          "name": "Learning",
          "status": "1",
          "sub_cat_id": "1"
      },
      {
          "id": 2,
          "description": null,
          "name": "Rhymes",
          "status": "1",
          "sub_cat_id": "2"
      },
      {
          "id": 3,
          "description": null,
          "name": "Story",
          "status": "1",
          "sub_cat_id": "3"
      }
  ],
  "videos": [
   {
      "id":1,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Are%20You%20Sleeping.png",
      "name":"Are You Sleeping",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Are%20You%20Sleeping.mp4"
   },
   {
      "id":2,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Ba%20Ba%20Black%20Sheep.png",
      "name":"Ba Ba Black Sheep",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Ba%20Ba%20Black%20Sheep.mp4"
   },
   {
      "id":3,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Children%20Finger%20Family%20Songs.png",
      "name":"Children Finger Family Songs",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Children%20Finger%20Family%20Songs.mp4"
   },
   {
      "id":4,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Five%20Little%20Monkeys%20Jumping%20On%20A%20Bed.png",
      "name":"Five Little Monkeys Jumping On A Bed",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Five%20Little%20Monkeys%20Jumping%20On%20A%20Bed.mp4"
   },
   {
      "id":5,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Grand%20Old%20Duke%20Of%20York.png",
      "name":"Grand Old Duke Of York",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Grand%20Old%20Duke%20Of%20York.mp4"
   },
   {
      "id":6,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Aladdin%20And%20The%20Magic%20Lamp.png",
      "name":"Aladdin And The Magic Lamp",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Aladdin%20And%20The%20Magic%20Lamp.mp4"
   },
   {
      "id":7,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Beauty%20And%20The%20Beast.png",
      "name":"Beauty And The Beast",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Beauty%20And%20The%20Beast.mp4"
   },
   {
      "id":8,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Bremen%20Musicians.png",
      "name":"Bremen Musicians",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Bremen%20Musicians.mp4"
   },
   {
      "id":9,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Fairy%20Tale.png",
      "name":"Fairy Tale",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Fairy%20Tale.mp4"
   },
   {
      "id":10,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/3d%20Shapes.png",
      "name":"3d Shapes",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/3d%20Shapes.mp4"
   },
   {
      "id":11,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/ABCD.png",
      "name":"ABCD",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/ABCD.mp4"
   },
   {
      "id":12,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Action%20Words.png",
      "name":"Action Words",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Action%20Words.mp4"
   },
   {
      "id":13,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Air%20Transportation.png",
      "name":"Air Transportation",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Air%20Transportation.mp4"
   },
   {
      "id":14,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Alphabet%20Party.png",
      "name":"Alphabet Party",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Alphabet%20Party.mp4"
   },
   {
      "id":15,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Alphabet%20Video.png",
      "name":"Alphabet Video",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Alphabet%20Video.mp4"
   },
   {
      "id":16,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Animals%20Colours.png",
      "name":"Animals Colours",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Animals%20Colours.mp4"
   },
   {
      "id":17,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Animals%20in%20Jungle.png",
      "name":"Animals in Jungle",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Animals%20in%20Jungle.mp4"
   },
   {
      "id":18,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Animals%20in%20the%20Farm.png",
      "name":"Animals in the Farm",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Animals%20in%20the%20Farm.mp4"
   },
   {
      "id":19,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Animal%20Song.png",
      "name":"Animal Song",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Animal%20Song.mp4"
   },
   {
      "id":20,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Baby%20Learn%20About%20Sea%20Animals.png",
      "name":"Baby Learn About Sea Animals",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Baby%20Learn%20About%20Sea%20Animals.mp4"
   },
   {
      "id":21,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Balloon%20Song.png",
      "name":"Balloon Song",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Balloon%20Song.mp4"
   },
   {
      "id":22,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Body%20Parts%20-%20Learning%20Rhymes.png",
      "name":"Body Parts - Learning Rhymes",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Body%20Parts%20-%20Learning%20Rhymes.mp4"
   },
   {
      "id":23,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Can%20and%20Cant.png",
      "name":"Can and Cant",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Can%20and%20Cant.mp4"
   },
   {
      "id":24,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Colors.png",
      "name":"Colors",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Colors.mp4"
   },
   {
      "id":25,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Counting%20By%20Tens.png",
      "name":"Counting By Tens",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Counting%20By%20Tens.mp4"
   },
   {
      "id":26,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Countings.png",
      "name":"Countings",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Countings.mp4"
   },
   {
      "id":27,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Days.png",
      "name":"Days",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Days.mp4"
   },
   {
      "id":28,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Different%20Occupations.png",
      "name":"Different Occupations",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Different%20Occupations.mp4"
   },
   {
      "id":29,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Dinosaur%201%20To%2010.png",
      "name":"Dinosaur 1 To 10",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Dinosaur%201%20To%2010.mp4"
   },
   {
      "id":30,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Dividing%20Fractions.png",
      "name":"Dividing Fractions",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Dividing%20Fractions.mp4"
   },
   {
      "id":31,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Domestic%20&%20Pet%20Animals.png",
      "name":"Domestic & Pet Animals",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Domestic%20&%20Pet%20Animals.mp4"
   },
   {
      "id":32,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Everything%20Beneath%20The%20Sea.png",
      "name":"Everything Beneath The Sea",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Everything%20Beneath%20The%20Sea.mp4"
   },
   {
      "id":33,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Feelings.png",
      "name":"Feelings",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Feelings.mp4"
   },
   {
      "id":34,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Flowers.png",
      "name":"Flowers",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Flowers.mp4"
   },
   {
      "id":35,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Forest%20Dance.png",
      "name":"Forest Dance",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Forest%20Dance.mp4"
   },
   {
      "id":36,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Fruit1.png",
      "name":"Fruit1",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Fruit1.mp4"
   },
   {
      "id":37,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Fruits2.png",
      "name":"Fruits2",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Fruits2.mp4"
   },
   {
      "id":38,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Fruits3.png",
      "name":"Fruits3",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Fruits3.mp4"
   },
   {
      "id":39,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/I%20Have%20A%20Tooth%20Brush.png",
      "name":"I Have A Tooth Brush",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/I%20Have%20A%20Tooth%20Brush.mp4"
   },
   {
      "id":40,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Insects.png",
      "name":"Insects",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Insects.mp4"
   },
   {
      "id":41,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Intro.png",
      "name":"Intro",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Intro.mp4"
   },
   {
      "id":42,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Job%20Song%20People%20Work.png",
      "name":"Job Song People Work",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Job%20Song%20People%20Work.mp4"
   },
   {
      "id":43,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Learn%20About%20Town.png",
      "name":"Learn About Town",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Learn%20About%20Town.mp4"
   },
   {
      "id":44,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Learn%20About%20Types%20Of%20Home.png",
      "name":"Learn About Types Of Home",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Learn%20About%20Types%20Of%20Home.mp4"
   },
   {
      "id":45,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Learning%20Addition.png",
      "name":"Learning Addition",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Learning%20Addition.mp4"
   },
   {
      "id":46,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Learning%20Bugs.png",
      "name":"Learning Bugs",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Learning%20Bugs.mp4"
   },
   {
      "id":47,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Learning%20Shapes.png",
      "name":"Learning Shapes",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Learning%20Shapes.mp4"
   },
   {
      "id":48,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Learning%20Subtraction.png",
      "name":"Learning Subtraction",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Learning%20Subtraction.mp4"
   },
   {
      "id":49,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Multiplying%20Fractions.png",
      "name":"Multiplying Fractions",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Multiplying%20Fractions.mp4"
   },
   {
      "id":50,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Names%20Of%20Animals.png",
      "name":"Names Of Animals",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Names%20Of%20Animals.mp4"
   },
   {
      "id":51,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Ocean%20Animals.png",
      "name":"Ocean Animals",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Ocean%20Animals.mp4"
   },
   {
      "id":52,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Roman%20Numerals.png",
      "name":"Roman Numerals",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Roman%20Numerals.mp4"
   },
   {
      "id":53,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Self%20Introduction.png",
      "name":"Self Introduction",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Self%20Introduction.mp4"
   },
   {
      "id":54,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Spotting%20Letters.png",
      "name":"Spotting Letters",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Spotting%20Letters.mp4"
   },
   {
      "id":55,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Standard%20Measurements.png",
      "name":"Standard Measurements",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Standard%20Measurements.mp4"
   },
   {
      "id":56,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/The%20Farm.png",
      "name":"The Farm",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/The%20Farm.mp4"
   },
   {
      "id":57,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Tooth%20Care.png",
      "name":"Tooth Care",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Tooth%20Care.mp4"
   },
   {
      "id":58,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Vegetables.png",
      "name":"Vegetables",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Vegetables.mp4"
   },
   {
      "id":59,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Vehicle%20Guessing%20Game.png",
      "name":"Vehicle Guessing Game",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Vehicle%20Guessing%20Game.mp4"
   },
   {
      "id":60,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Vowels.png",
      "name":"Vowels",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Vowels.mp4"
   },
   {
      "id":61,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Water%20Animals_2.png",
      "name":"Water Animals_2",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Water%20Animals_2.mp4"
   },
   {
      "id":62,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Weather.png",
      "name":"Weather",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Weather.mp4"
   },
   {
      "id":63,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Whose%20Ears.png",
      "name":"Whose Ears",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Whose%20Ears.mp4"
   },
   {
      "id":64,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Whose%20Feet.png",
      "name":"Whose Feet",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Whose%20Feet.mp4"
   },
   {
      "id":65,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Whose%20Mouth.png",
      "name":"Whose Mouth",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Whose%20Mouth.mp4"
   },
   {
      "id":66,
      "category":"Learning",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/image/Whose%20Tail.png",
      "name":"Whose Tail",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Learning%20Videos/Whose%20Tail.mp4"
   },
   {
      "id":67,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Hot%20Cross%20Buns.png ",
      "name":"Hot Cross Buns",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Hot%20Cross%20Buns.mp4"
   },
   {
      "id":68,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Humpty%20Dumpty.png ",
      "name":"Humpty Dumpty",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Humpty%20Dumpty.mp4"
   },
   {
      "id":69,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/I%20am%20A%20Little%20Teapot.png",
      "name":"I am A Little Teapot",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/I%20am%20A%20Little%20Teapot.mp4"
   },
   {
      "id":70,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Itsy%20Bitsy%20Spider.png ",
      "name":"Itsy Bitsy Spider",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Itsy%20Bitsy%20Spider.mp4"
   },
   {
      "id":71,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Jingle%20Bells.png ",
      "name":"Jingle Bells",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Jingle%20Bells.mp4"
   },
   {
      "id":72,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Johny%20Johny.png ",
      "name":"Johny Johny",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Johny%20Johny.mp4"
   },
   {
      "id":73,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Keep%20Safe%20Stay%20Alive.png ",
      "name":"Keep Safe Stay Alive",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Keep%20Safe%20Stay%20Alive.mp4"
   },
   {
      "id":74,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Ladybug%20Song.png ",
      "name":"Ladybug Song",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Ladybug%20Song.mp4"
   },
   {
      "id":75,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Lets%20Be%20Planes.png ",
      "name":"Lets Be Planes",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Lets%20Be%20Planes.mp4"
   },
   {
      "id":76,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Like%20Dont%20Like.png",
      "name":"Like Dont Like",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Like%20Dont%20Like.mp4"
   },
   {
      "id":77,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Mary%20Had%20A%20Little%20Lamb.png ",
      "name":"Mary Had A Little Lamb",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Mary%20Had%20A%20Little%20Lamb.mp4"
   },
   {
      "id":78,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Open%20Close.png ",
      "name":"Open Close",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Open%20Close.mp4"
   },
   {
      "id":79,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Under%20the%20Banana%20Tree.png ",
      "name":"Under the Banana Tree",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Under%20the%20Banana%20Tree.mp4"
   },
   {
      "id":80,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Ba%20Ba%20Black%20Sheep.png",
      "name":"Ba Ba Black Sheep",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Ba%20Ba%20Black%20Sheep.mp4"
   },
   {
      "id":81,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Children%20Finger%20Family%20Songs.png ",
      "name":"Children Finger Family Songs",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Children%20Finger%20Family%20Songs.mp4"
   },
   {
      "id":82,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Five%20Little%20Monkeys%20Jumping%20On%20A%20Bed.png ",
      "name":"Five Little Monkeys Jumping On A Bed",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Five%20Little%20Monkeys%20Jumping%20On%20A%20Bed.mp4"
   },
   {
      "id":83,
      "category":"Rhymes",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Rhymes/Grand%20Old%20Duke%20Of%20York.png ",
      "name":"Grand Old Duke Of York",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Rhymes/Grand%20Old%20Duke%20Of%20York.mp4"
   },
   {
      "id":84,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Aladdin%20And%20The%20Magic%20Lamp.png",
      "name":"Aladdin And The Magic Lamp ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Aladdin%20And%20The%20Magic%20Lamp.mp4"
   },
   {
      "id":85,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Beauty%20And%20The%20Beast.png",
      "name":"Beauty And The Beast ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Beauty%20And%20The%20Beast.mp4"
   },
   {
      "id":86,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Bremen%20Musicians.png",
      "name":"Bremen Musicians ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Bremen%20Musicians.mp4"
   },
   {
      "id":87,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Fairy%20Tale.png",
      "name":"Fairy Tale ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Fairy%20Tale.mp4"
   },
   {
      "id":88,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Hansel%20And%20Gretel.png",
      "name":"Hansel And Gretel ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Hansel%20And%20Gretel.mp4"
   },
   {
      "id":89,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Heidi%20-%20The%20Girl%20Of%20The%20Alps.png",
      "name":"Heidi - The Girl Of The Alps ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Heidi%20-%20The%20Girl%20Of%20The%20Alps.mp4"
   },
   {
      "id":90,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Mullah's%20Wife%20-Mullah%20Nasruddin.png",
      "name":"Mullahs Wife -Mullah Nasruddin ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Mullah's%20Wife%20-Mullah%20Nasruddin.mp4"
   },
   {
      "id":91,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Pinocchio%20Kids%20Story.png",
      "name":"Pinocchio Kids Story ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Pinocchio%20Kids%20Story.mp4"
   },
   {
      "id":92,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Puss%20In%20Boots%20Kids%20Story.png",
      "name":"Puss In Boots Kids Story ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Puss%20In%20Boots%20Kids%20Story.mp4"
   },
   {
      "id":93,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Rapunzel.png",
      "name":"Rapunzel ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Rapunzel.mp4"
   },
   {
      "id":94,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Singing%20Donkey.png",
      "name":"Singing Donkey ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Singing%20Donkey.mp4"
   },
   {
      "id":95,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Snow%20Queen.png",
      "name":"Snow Queen ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Snow%20Queen.mp4"
   },
   {
      "id":96,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Snow%20White.png",
      "name":"Snow White ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Snow%20White.mp4"
   },
   {
      "id":97,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Snowwhite%20&%20The%20Seven%20Dwarfs.png",
      "name":"Snowwhite & The Seven Dwarfs ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Snowwhite%20&%20The%20Seven%20Dwarfs.mp4"
   },
   {
      "id":98,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/The%20Boy's%20Journey.png",
      "name":"The Boys Journey ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/The%20Boy's%20Journey.mp4"
   },
   {
      "id":99,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/The%20Boy%20Who%20Cried%20Wolf.png",
      "name":"The Boy Who Cried Wolf",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/The%20Boy%20Who%20Cried%20Wolf.mp4"
   },
   {
      "id":100,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Aladdin%20And%20The%20Magic%20Lamp.png",
      "name":"Aladdin And The Magic Lamp ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Aladdin%20And%20The%20Magic%20Lamp.mp4"
   },
   {
      "id":101,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Beauty%20And%20The%20Beast.png",
      "name":"Beauty And The Beast ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Beauty%20And%20The%20Beast.mp4"
   },
   {
      "id":102,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Bremen%20Musicians.png",
      "name":"Bremen Musicians ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Bremen%20Musicians.mp4"
   },
   {
      "id":103,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Fairy%20Tale.png",
      "name":"Fairy Tale ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Fairy%20Tale.mp4"
   },
   {
      "id":104,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Hansel%20And%20Gretel.png",
      "name":"Hansel And Gretel ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Hansel%20And%20Gretel.mp4"
   },
   {
      "id":105,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Hansel%20And%20Gretel.png.filepart",
      "name":"Hansel And Gretel .filepart",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Hansel%20And%20Gretel.mp4"
   },
   {
      "id":106,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Heidi%20-%20The%20Girl%20Of%20The%20Alps.png",
      "name":"Heidi - The Girl Of The Alps ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Heidi%20-%20The%20Girl%20Of%20The%20Alps.mp4"
   },
   {
      "id":107,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Mullah's%20Wife%20-Mullah%20Nasruddin.png",
      "name":"Mullahs Wife -Mullah Nasruddin ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Mullah's%20Wife%20-Mullah%20Nasruddin.mp4"
   },
   {
      "id":108,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Pinocchio%20Kids%20Story.png",
      "name":"Pinocchio Kids Story ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Pinocchio%20Kids%20Story.mp4"
   },
   {
      "id":109,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Puss%20In%20Boots%20Kids%20Story.png",
      "name":"Puss In Boots Kids Story ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Puss%20In%20Boots%20Kids%20Story.mp4"
   },
   {
      "id":110,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Rapunzel.png",
      "name":"Rapunzel ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Rapunzel.mp4"
   },
   {
      "id":111,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Singing%20Donkey.png",
      "name":"Singing Donkey ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Singing%20Donkey.mp4"
   },
   {
      "id":112,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Snow%20Queen.png",
      "name":"Snow Queen ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Snow%20Queen.mp4"
   },
   {
      "id":113,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Snow%20White.png",
      "name":"Snow White ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Snow%20White.mp4"
   },
   {
      "id":114,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Snowwhite%20&%20The%20Seven%20Dwarfs.png",
      "name":"Snowwhite & The Seven Dwarfs ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Snowwhite%20&%20The%20Seven%20Dwarfs.mp4"
   },
   {
      "id":115,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/The%20Boy's%20Journey.png",
      "name":"The Boys Journey ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/The%20Boy's%20Journey.mp4"
   },
   {
      "id":116,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/The%20Boy%20Who%20Cried%20Wolf.png",
      "name":"The Boy Who Cried Wolf",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/The%20Boy%20Who%20Cried%20Wolf.mp4"
   },
   {
      "id":117,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Aladdin%20And%20The%20Magic%20Lamp.png",
      "name":"Aladdin And The Magic Lamp ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Aladdin%20And%20The%20Magic%20Lamp.mp4"
   },
   {
      "id":118,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Beauty%20And%20The%20Beast.png",
      "name":"Beauty And The Beast ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Beauty%20And%20The%20Beast.mp4"
   },
   {
      "id":119,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Bremen%20Musicians.png",
      "name":"Bremen Musicians ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Bremen%20Musicians.mp4"
   },
   {
      "id":120,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Fairy%20Tale.png",
      "name":"Fairy Tale ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Fairy%20Tale.mp4"
   },
   {
      "id":121,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Hansel%20And%20Gretel.png",
      "name":"Hansel And Gretel ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Hansel%20And%20Gretel.mp4"
   },
   {
      "id":122,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Hansel%20And%20Gretel.png.filepart",
      "name":"Hansel And Gretel .filepart",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Hansel%20And%20Gretel.mp4"
   },
   {
      "id":123,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Heidi%20-%20The%20Girl%20Of%20The%20Alps.png",
      "name":"Heidi - The Girl Of The Alps ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Heidi%20-%20The%20Girl%20Of%20The%20Alps.mp4"
   },
   {
      "id":124,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Mullah's%20Wife%20-Mullah%20Nasruddin.png",
      "name":"Mullahs Wife -Mullah Nasruddin ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Mullah's%20Wife%20-Mullah%20Nasruddin.mp4"
   },
   {
      "id":125,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Pinocchio%20Kids%20Story.png",
      "name":"Pinocchio Kids Story ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Pinocchio%20Kids%20Story.mp4"
   },
   {
      "id":126,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Puss%20In%20Boots%20Kids%20Story.png",
      "name":"Puss In Boots Kids Story ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Puss%20In%20Boots%20Kids%20Story.mp4"
   },
   {
      "id":127,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Rapunzel.png",
      "name":"Rapunzel ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Rapunzel.mp4"
   },
   {
      "id":128,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Singing%20Donkey.png",
      "name":"Singing Donkey ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Singing%20Donkey.mp4"
   },
   {
      "id":129,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Snow%20Queen.png",
      "name":"Snow Queen ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Snow%20Queen.mp4"
   },
   {
      "id":130,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Snow%20White.png",
      "name":"Snow White ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Snow%20White.mp4"
   },
   {
      "id":131,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Snowwhite%20&%20The%20Seven%20Dwarfs.png",
      "name":"Snowwhite & The Seven Dwarfs ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Snowwhite%20&%20The%20Seven%20Dwarfs.mp4"
   },
   {
      "id":132,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/The%20Boy's%20Journey.png",
      "name":"The Boys Journey ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/The%20Boy's%20Journey.mp4"
   },
   {
      "id":133,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/The%20Boy%20Who%20Cried%20Wolf.png",
      "name":"The Boy Who Cried Wolf",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/The%20Boy%20Who%20Cried%20Wolf.mp4"
   },
   {
      "id":134,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Aladdin%20And%20The%20Magic%20Lamp.png",
      "name":"Aladdin And The Magic Lamp ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Aladdin%20And%20The%20Magic%20Lamp.mp4"
   },
   {
      "id":135,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Beauty%20And%20The%20Beast.png",
      "name":"Beauty And The Beast ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Beauty%20And%20The%20Beast.mp4"
   },
   {
      "id":136,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Bremen%20Musicians.png",
      "name":"Bremen Musicians ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Bremen%20Musicians.mp4"
   },
   {
      "id":137,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Fairy%20Tale.png",
      "name":"Fairy Tale ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Fairy%20Tale.mp4"
   },
   {
      "id":138,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Hansel%20And%20Gretel.png",
      "name":"Hansel And Gretel ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Hansel%20And%20Gretel.mp4"
   },
   {
      "id":139,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Hansel%20And%20Gretel.png.filepart",
      "name":"Hansel And Gretel .filepart",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Hansel%20And%20Gretel.mp4"
   },
   {
      "id":140,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Heidi%20-%20The%20Girl%20Of%20The%20Alps.png",
      "name":"Heidi - The Girl Of The Alps ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Heidi%20-%20The%20Girl%20Of%20The%20Alps.mp4"
   },
   {
      "id":141,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Mullah's%20Wife%20-Mullah%20Nasruddin.png",
      "name":"Mullahs Wife -Mullah Nasruddin ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Mullah's%20Wife%20-Mullah%20Nasruddin.mp4"
   },
   {
      "id":142,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Pinocchio%20Kids%20Story.png",
      "name":"Pinocchio Kids Story ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Pinocchio%20Kids%20Story.mp4"
   },
   {
      "id":143,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Puss%20In%20Boots%20Kids%20Story.png",
      "name":"Puss In Boots Kids Story ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Puss%20In%20Boots%20Kids%20Story.mp4"
   },
   {
      "id":144,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Rapunzel.png",
      "name":"Rapunzel ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Rapunzel.mp4"
   },
   {
      "id":145,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Singing%20Donkey.png",
      "name":"Singing Donkey ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Singing%20Donkey.mp4"
   },
   {
      "id":146,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Snow%20Queen.png",
      "name":"Snow Queen ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Snow%20Queen.mp4"
   },
   {
      "id":147,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Snow%20White.png",
      "name":"Snow White ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Snow%20White.mp4"
   },
   {
      "id":148,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/Snowwhite%20&%20The%20Seven%20Dwarfs.png",
      "name":"Snowwhite & The Seven Dwarfs ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/Snowwhite%20&%20The%20Seven%20Dwarfs.mp4"
   },
   {
      "id":149,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/The%20Boy's%20Journey.png",
      "name":"The Boys Journey ",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/The%20Boy's%20Journey.mp4"
   },
   {
      "id":150,
      "category":"Story",
      "description":null,
      "imageUrl":"https://ocm.kiddzmania.com/KidsVideos/Images/Stories/The%20Boy%20Who%20Cried%20Wolf.png",
      "name":"The Boy Who Cried Wolf",
      "status":"1",
      "videoUrl":"https://ocm.kiddzmania.com/KidsVideos/videos/Story%20videos/The%20Boy%20Who%20Cried%20Wolf.mp4"
   }
]
}
                     

export default gameConfig

